export const environment = {
  production: true,
  enableLogging: true,
  name: "INT",
  apiBaseUrl: "https://int-fleetweb.vwfs.se/api"
};
